import { DiagnosisItem } from "../../diagnosis.model";
import { Tooth } from "../../../../odontogram/odontogram.model";
import { ItemValidators } from "../../../item-validators";
import { AbstractCondition } from "../condition";

/**
 * Options:
 *    - degree
 */
export class Gingivitis extends AbstractCondition {
  static validate(
    item: DiagnosisItem,
    odontogram: Tooth[],
    items: DiagnosisItem[],
  ): boolean {
    // validate degree
    if (!ItemValidators.hasDegreeSelected(item)) {
      return false;
    }

    return true;
  }

  static apply(odontogram: Tooth[], item: DiagnosisItem): Tooth[] {
    return odontogram;
  }

  static getDiagnosis360Changes(item: DiagnosisItem): any {
    return {
      gum_disease: true,
    };
  }

  static supports(condition: string): boolean {
    return condition === "gingivitis";
  }

  static getItemResume(item: DiagnosisItem): any {
    return [
      {
        name: "degree",
        value: item.options.degree
          ? ["diagnosis.options.degree." + item.options.degree]
          : [],
      },
    ];
  }

  static getTableData(item: DiagnosisItem): any {
    return [
      "",
      item.options.degree
        ? ["diagnosis.options.degree." + item.options.degree]
        : [],
    ];
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/conditions/perio/gingivitis.ts